import { Module } from '@nestjs/common';
import { PersonasModule } from 'src/personas/personas.module';
import { ChofereController } from './choferes.controller';
import { ChofereService } from './choferes.service';

@Module({
  imports: [PersonasModule],
  controllers: [ChofereController],
  providers: [ChofereService],
  exports: [ChofereService],
})
export class ChofereModule {}
